export const USERNAME_INPUT_INFO =
    "This will either be your client reference starting '100' or your registered email address.";
